<div class="full-screen-dialog create-new">
  <button class="floating-close-button" [mat-dialog-close]>
    <svg-icon-sprite style="color:white;" [src]="'assets/images/svgIconsSprite.svg#cross'" [width]="'24px'">
    </svg-icon-sprite>
  </button>
  <h1 mat-dialog-title class="text-center">Choose a type to create</h1>
  <mat-dialog-content>
    <div class="container actions-container">
      <div class="row text-center">
        <div class="col-sm">
          <svg-icon-sprite [src]="'assets/images/svgImagesSprite.svg#create_dc'"></svg-icon-sprite>
          <h3>Config</h3>
          <p>Configs are key-data pairs which can be used to define and modify <br /> user experience</p>
          <button class="primary-btn" mat-flat-button [mat-dialog-close]="'create-dc'">CREATE A CONFIG</button>
        </div>
        <div class="col-sm">
          <svg-icon-sprite [src]="'assets/images/svgImagesSprite.svg#module'"></svg-icon-sprite>
          <h3>Native Nudge</h3>
          <p>Native nudges are groupings of configs used to deliver nudges on the native layer.</p>
          <button class="primary-btn" mat-flat-button [mat-dialog-close]="'create-module'">CREATE NATIVE NUDGE</button>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
